module.exports = __webpack_public_path__ + "static/media/homepageImg.3c6933a7.svg";